import { LogoEmak, LogoEmakGroup } from '@components/icons'
import React from 'react'

const loghi = {
  5: <LogoEmak />,
  6: <LogoEmakGroup />,
}

const Logo = () => {
  return loghi[process.env.SITE_ID]
}

export default Logo
